import React from "react"
import Link from "../../../../components/basics/Link"
import PropTypes from "prop-types"

const ProductLink = ({ to, label, description, onClick, icon = undefined, blank = false }) => {
  return <Link to={to} className="text-link-unstyled" onClick={() => onClick()} blank={blank}>
    <div className="pt-1.5 pb-1.5">
      <div className="text-medium text-midnight-10 font-bold flex items-center">
        {label}
        {icon !== undefined && icon}
      </div>
      <div className="text-small text-midnight-20 mt-0.5">{description}</div>
    </div>
  </Link>
}

ProductLink.propTypes = {
  to: PropTypes.string,
  label: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.element,
  blank: PropTypes.bool,
  onClick: PropTypes.func
}

export default ProductLink